import React, { useContext, useEffect, useState } from 'react';
import MyContext from '../../context/MyContext';
import AuthContext from '../../context/userAuth.context';

const SoundPlay = ({ value, TickerPosition, isPlayClicked, ComingFrom }) => {

    // const { CanvasDisplay, onePxEquivalent, setCanvasDisplay } = useContext(MyContext)
    // const { authenticationData } = useContext(AuthContext)
    // const [playing, setPlaying] = useState(true);

    // const useAudio = (url) => {
        
    //     const [audio] = useState(new Audio(url));
    //     //const toggle = (data) => setPlaying(data);
    //     useEffect(() => {
    //         if(ComingFrom != "EditorTracker")
    //         {
    //             playing ? audio.play() : audio.pause();
    //         }
           
    //         // if (playing === true) {
    //         //     audio.play()
    //         // } else {
    //         //     audio.pause()
    //         //     // audio.currentTime = 0;
    //         // }
    //     }, [playing]);

    //     // useEffect(() => {
    //     //     audio.a ddEventListener('ended', () => setPlaying(false));
    //     //     return () => {
    //     //         audio.removeEventListener('ended', () => setPlaying(false));
    //     //     };
    //     // }, []);

    //     return [audio];
    // };

    // const [audio] = useAudio(authenticationData.ApiBaseURL + '/' + value.path);

    // // useEffect(() => {
    // //     // debugger
    // //     if (!CanvasDisplay) {
    // //         if (value.player) {
    // //             if (!playing) {                    
    // //                 if (TickerPosition > value.startPositionOnTimeline) {

    // //                     console.log("Start Sound......")
    // //                     console.log(value.startSound)
    // //                     let width;
    // //                     if(value.startSound)
    // //                     {
    // //                         width = TickerPosition - value.startSound
    // //                     }
    // //                     else
    // //                     {
    // //                         width = TickerPosition - value.startPositionOnTimeline
    // //                     }
                        
    // //                     let time
    // //                     if (width < 1) {
    // //                         time = 0
    // //                     } else {

    // //                         time = width * onePxEquivalent
    // //                         time = time / 1000
    // //                     }

    // //                     audio.currentTime = time
    // //                     setPlaying(true)
    // //                 } else {
    // //                     audio.currentTime = 0
    // //                     setPlaying(true)
    // //                 }
    // //             }
    // //         } else {
    // //             audio.currentTime = 0
    // //             setPlaying(true)
    // //         }
    // //     }
    // // }, [playing])

    // useEffect(() => {     

    //     if(ComingFrom != "EditorTracker")
    //     {
    //         if (value.startMusic) {
    //             // debugger
    //             if(isPlayClicked)
    //             {
                    
    //                 setPlaying(false)
    //                 setCanvasDisplay(false)
    //             }
    //             else
    //             {             
    //                 setPlaying(true)
    //                 if(audio)
    //                 {
    //                     if(audio.played)
    //                     {
    //                         audio.pause();
    //                     }
    //                 }
    //             }
    //         }
    //         else
    //         {            
    //             if(audio)
    //             {
    //                 if(!audio.paused)
    //                 {
    //                     audio.pause()
    //                 }
    //             }
    //         }
    //     }
        
    
     
    // }, [isPlayClicked, value.startMusic])
    

    // useEffect(() => {
    //     if(ComingFrom != "EditorTracker")
    //     {
    //         if (CanvasDisplay) {
    //             if (playing) {
    //                 if(audio)
    //                 {
    //                     if(audio.played)
    //                     {
    //                         audio.pause();
    //                     }
    //                 }
    //                 // setPlaying(false)
    //                 // audio.currentTime = 0
    //             }
    //         }
    //     }
        
    // }, [CanvasDisplay])

    return (
        <>
        </>
    );
};

export default SoundPlay;